/**
 * Enhanced service for retrieving receipt URLs from the Stripe API
 * This service handles error cases more robustly and provides detailed logging
 */

import axios from 'axios';

// Deployed backend URL
const BACKEND_URL = 'https://fredo-backend-f1b69e586976.herokuapp.com';

/**
 * Gets the receipt URL for a completed Stripe checkout session
 * @param {string} sessionId - The Stripe checkout session ID
 * @returns {Promise<string|null>} - The receipt URL or null if not available
 */
async function getReceiptUrl(sessionId) {
  if (!sessionId) {
    console.error('No session ID provided');
    return null;
  }

  try {
    // Add a timestamp to prevent caching
    const timestamp = Date.now();
    const url = `${BACKEND_URL}/api/receipts?session_id=${sessionId}&_=${timestamp}`;
    
    const response = await axios.get(url, {
      headers: {
        'Accept': 'application/json'
      },
      // Explicitly set for CORS
      withCredentials: false
    });
    
    // Axios automatically checks for non-2xx responses
    
    // Check for receipt URL
    if (response.data && response.data.receipt_url) {
      return response.data.receipt_url;
    } else if (response.data && response.data.error) {
      console.error(`API returned error: ${response.data.error}`);
    } else {
      console.warn('No receipt URL available yet');
    }
    
    return null;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Axios error retrieving receipt URL:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText
      });
      
      if (error.response?.data?.error) {
        console.error(`API error message: ${error.response.data.error}`);
      }
    } else {
      console.error('Error retrieving receipt URL:', error);
    }
    return null;
  }
}

export default getReceiptUrl; 